import { dynamicImage } from "../../../Service/DynamicImage";

// Borders And Displays
export const BORDER_DATA = [
  { text: "Use border utilities to add or remove an element's borders." },
];

export const ADDITIVE_DATA = [
  "border-top",
  "border-bottom",
  "border-start",
  "border-end",
];

export const SUBTRACTIVE_DATA = [
  "border-top-0",
  "border-end-0",
  "border-bottom-0",
  "border-start-0",
];

export const RADIUS_DATA = [
  "rounded-top",
  "rounded-end",
  "rounded-bottom",
  "rounded-start",
  "rounded-pill",
  "rounded-circle",
  "rounded-0",
];

// Styles In Borders
export const STYLE_DATA = [
  {
    text: "Use the different styles of borders like:",
    code: "border radius/border-color/border-width",
  },
  { text: ". Use of any components." },
];

export const BORDER_CLASS = [
  "b-r-1",
  "b-r-2",
  "b-r-3",
  "b-r-4",
  "b-r-5",
  "b-r-6",
  "b-r-7",
  "b-r-8",
  "b-r-9",
  "b-r-10",
];

export const BORDER_COLOR = [
  "border-secondary",
  "border-success",
  "border-danger",
  "border-warning",
  "border-info",
  "border-dark",
];

export const BORDER_WIDTH = [
  "border-2",
  "border-3",
  "border-4",
  "border-5",
  "border-6",
  "border-7",
  "border-8",
  "border-9",
  "border-10",
];

export const TEXT_COLOR = [
  { className: "txt-secondary" },
  { className: "txt-success" },
  { className: "txt-danger" },
  { className: "txt-warning" },
  { className: "txt-info" },
  { className: " txt-dark" },
  { className: "txt-light", className2: "bg-dark" },
];

// Styles Background Colors
export const BACKGROUND_DATE = [
  { text: "Use the ", code: ".bg-* " },
  { text: "and ", code: ".alert-light-*" },
  { text: "colors in Boho theme.Use of any components." },
];

export const DARK_BACKGROUND = [
  "bg-secondary",
  "bg-success",
  "bg-danger",
  "bg-warning",
  "bg-info",
  "bg-dark",
  "bg-light",
];

export const LIGHT_BACKGROUND = [
  "alert-light-secondary",
  "alert-light-success",
  "alert-light-danger",
  "alert-light-warning",
  "alert-light-info",
  "alert-light-dark",
  "alert-light-light",
];

// Border Color
export const BORDER_COLOR_DATA = [
  { text: " Use the ", code: ".b-*/.b-t-*/.b-b-*/.b-l-*/.b-r-*" },
  { text: "class for borders." },
];

export const BORDER_COLORS = [
  "b-t-primary",
  "b-b-primary",
  "b-l-primary",
  "b-r-primary",
  "b-secondary",
  "b-t-secondary",
  "b-b-secondary",
  ".b-l-secondary",
  "b-r-secondary",
  "b-success",
  ".b-t-success",
  "..b-b-success",
  ".b-l-success",
  ".b-r-success",
  ".b-danger",
  "b-t-danger",
  ".b-b-danger",
  "b-l-danger",
  "b-r-danger",
  ".b-danger",
  "b-t-danger",
  ".b-b-danger",
  "b-l-danger",
  "b-r-danger",
  ".b-warning",
  "b-t-warning",
  ".b-b-warning",
  "b-l-warning",
  "b-r-warning",
  ".b-info",
  "b-t-info",
  ".b-b-info",
  "b-l-info",
  "b-r-info",
  ".b-dark",
  "b-t-dark",
  ".b-b-dark",
  "b-l-dark",
  "b-r-dark",
  ".b-light",
  "b-t-light",
  ".b-b-light",
  "b-l-light",
  "b-r-light",
];

// Images Sizes
export const IMAGE_DATA = [
  { text: "Use the width and height of images class like: ", code: ".img-*" },
  { text: "and", code: ".img-h-*" },
];

export const IMAGES = [
  {
    className: "img-20 img-h-20",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-20",
  },
  {
    className: "img-30 img-h-30",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-30",
  },
  {
    className: "img-40 img-h-40",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-40",
  },
  {
    className: "img-50 img-h-50",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-50",
  },
  {
    className: "img-60 img-h-60",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-60",
  },
  {
    className: "img-70 img-h-70",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-70",
  },
  {
    className: "img-80 img-h-80",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-80",
  },
  {
    className: "img-90 img-h-90",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-90",
  },
  {
    className: "img-100 img-h-100",
    src: dynamicImage("blog/comment.jpg"),
    alt: "img-size-100",
  },
];

// Font-Style
export const FONT_DATA = [
  {
    text: "Use the font-style like: ",
    code: " .f-s-* [normal/italic/oblique/initial/inherit]",
  },
];

export const FONT_STYLE = [
  "f-s-italic",
  "f-s-oblique",
  "f-s-initial",
  "f-s-inherit",
];

// Font Weight
export const FONT_WEIGHT = [
  {
    text: "Use the font-weight classes like: ",
    code: ".f-w-* [100/300/400/600/700/900]",
  },
];

export const FONT_WEIGHT_DATA = [
  "f-w-300",
  "f-w-400",
  "f-w-600",
  "f-w-700",
  "f-w-900",
];

// Text Colors
export const TEXT_COLOR_DATA = [
  { text: "Use the text color for ", code: ".font-*" },
  { text: " class." },
];

export const TEXT_COLORS = [
  "font-secondary",
  "font-success",
  "font-danger",
  "font-warning",
  "font-info",
  "font-dark",
];

// Font Sizes
export const FONT_SIZES = [
  {
    text: "Use the font-size for ",
    code: ".f-* [14/16/18/20/22/24/26/28/30/32/34/36/38/40]",
  },
];

export const FONT_SIZE = [
  "f-14",
  "f-16",
  "f-18",
  "f-20",
  "f-22",
  "f-24",
  "f-26",
  "f-28",
  "f-30",
  "f-32",
  "f-34",
  "f-36",
  "f-38",
  "f-40",
];
